import {
  put, takeLatest, take, select,
} from 'redux-saga/effects';

import {
  USER_REGISTRATION_REQUEST,
} from '@/action-types/user';

import {
  REGISTRATION_TEACHER_PAY_REQUEST,
} from '@/action-types/login';

import {
  CLIENT_STATE_UPDATE,
  UPDATE_INSTRUCTION_REQUEST,
} from '@/action-types/client-state';
import { CHANGE_PAGE } from '@/action-types/app';

export function* getInstruction() {
  while (true) {
    const state = yield select();
    const { pathname } = yield take(CHANGE_PAGE);

    const isViewedInstruction = state?.clientState?.instruction.isViewedInstruction;

    if ((pathname === '/teacher/' || pathname.includes('/student/')) && isViewedInstruction !== 1) {
      yield put({
        type: CLIENT_STATE_UPDATE,
        state: {
          instruction: {
            isViewedInstruction: 0,
          },
        },
      });

      break;
    }
  }
}

export function* updateInstruction() {
  yield put({
    type: CLIENT_STATE_UPDATE,
    state: {
      instruction: {
        isViewedInstruction: 1,
      },
    },
  });
}

export default function* clientState() {
  yield takeLatest(USER_REGISTRATION_REQUEST, getInstruction);
  yield takeLatest(REGISTRATION_TEACHER_PAY_REQUEST, getInstruction);
  yield takeLatest(UPDATE_INSTRUCTION_REQUEST, updateInstruction);
}
